import { __assign } from '../../../../_virtual/_tslib.js';
import React from 'react';
import Profile from '../Profile/Profile.js';
import { classNames } from '../../../../utils/common/styling.js';
import { styles } from './SidebarWrapper.styles.js';
import { DEFAULT_LISTING_IMG_SRC } from '../../../../assets/listings.js';
import { DEFAULT_CREATOR_THEME } from '../../../../features/Common/modules/Theme/constants/Theme.constants.js';
import { CreatorThemeContext } from '../../../../features/Common/modules/Theme/CreatorThemeContext.js';

var SidebarWrapper = function (_a) {
    var children = _a.children, _b = _a.showDividers, hasDividers = _b === void 0 ? true : _b, profileProps = _a.profileProps, className = _a.className, bodyClassName = _a.bodyClassName, configClassName = _a.configClassName, dividerClassName = _a.dividerClassName, coverImageClassName = _a.coverImageClassName, _c = _a.theme, theme = _c === void 0 ? DEFAULT_CREATOR_THEME : _c;
    var coverImage = (profileProps || {}).coverImage;
    var totalChildrens = Array.isArray(children) ? children.length : 1;
    return (React.createElement(CreatorThemeContext.Provider, { value: theme },
        React.createElement("div", { className: classNames(styles.root, className) },
            React.createElement("img", { src: coverImage || DEFAULT_LISTING_IMG_SRC, alt: "cover", className: classNames(styles.cover, coverImageClassName) }),
            React.createElement("div", { className: classNames(styles.body, bodyClassName) },
                React.createElement(Profile, __assign({}, profileProps)),
                React.createElement("div", { className: classNames(styles.config, configClassName) }, hasDividers
                    ? React.Children.map(children, function (children, index) { return (React.createElement(React.Fragment, { key: children.key },
                        children,
                        index < totalChildrens - 1 && (React.createElement("hr", { className: classNames(styles.divider, dividerClassName) })))); })
                    : children)))));
};

export { SidebarWrapper as default };
//# sourceMappingURL=SidebarWrapper.js.map
